module.exports = __webpack_public_path__ + "static/bg_cardboard-b7b519f29b9e9ba4376d7b717240fa16.jpg";